export default from './Psychic';



// WEBPACK FOOTER //
// ./src/elements/psychic/index.jsx